
const filterSuggestions = (triggers, suggestions) => suggestions.filter(
  suggestion =>
    !triggers.some(trigger =>
      trigger.phrases.some(phraseObject =>
        phraseObject.phrase.toLowerCase() === suggestion.missedText.toLowerCase()),
    ),
);

export {
  filterSuggestions,
}
